import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getRazorPayTransactionList, getPaymentLinkInfoDetail, partnerSubscription, partnerSubscriptionAfterRazorPayLinks } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';


class paymentsLinksDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            detail:{},
            upgradeList: [],
        }

        this.id = this.props.match.params.id ? this.props.match.params.id : '';
        this.getPaymentDetail = this.getPaymentDetail.bind(this);
    }
    componentDidMount() {

        this.getPaymentDetail();
        this.getCurrentPlanList();

    }

 
   getCurrentPlanList = () => {

    let insdata = JSON.stringify({
      user_type: 2,
      partner_id: this.state.vendor_id,
      role: 3,
      url: 'getPartnerPlanV1'
    });
    partnerSubscription(insdata).then((response) => {
      if (response.status === 1) {
        this.setState({
          package_list: response.plan_list,
          upgradeList: response.upgrade_list,
          cgst_per: response.tax_data.cgst,
          sgst_per: response.tax_data.sgst,
          coupon_id: response.coupon_data.coupon_id,
          coupon_per_or: response.coupon_data.coupon_per,
          coupon_amount_or: response.coupon_data.coupon_amount,
          partner_name: response.partner.name, partner_email: response.partner.email, partner_address: response.partner.address
        })
      }
    })
    }

    async getPaymentDetail() {


        let req = JSON.stringify({
         id: this.id
        });

    getPaymentLinkInfoDetail(req).then((response) => {
        if (response.status === 1) {
            this.setState({
                detail: response.detail,
                vendor_id:response.detail.vendor_id
            })
        }else{
            this.setState({
            detail: {}
            })
        }
    });

    }  
 
    componentDidUpdate() {
         

    }

  // handlePaySubmit = () => {
  handlePaySubmit = () => {
    let razorpay_payment_id = this.state.payment_id;

    if (razorpay_payment_id != '') {
      let ins = '';
      let upgradeList = this.state.upgradeList.filter((item) => (item.is_check === true && item.nplanid != 0 && parseInt(item.period) > 0));
      ins = JSON.stringify({
        razorpay_payment_id: this.state.payment_id,
        razorpay_order_id: this.state.order_id,
        razorpay_signature: this.state.razorpay_signature,
        basesubtotal: Number.parseFloat(this.state.amount).toFixed(2),
        subtotal: Number.parseFloat(this.state.amount).toFixed(2),
        discount_per: this.state.discount_per,
        discount_amount: this.state.discount_amount,
        coupon_per: 0.00,
        totalpayable: Number.parseFloat(this.state.amount).toFixed(2), 
        user_type: 2,
        period:this.state.period,
        user_paytype: 1,
        invoice_type: 2,
        upgradeList: upgradeList,
        login_id: this.state.vendor_id,
        url: 'updatevendorplan',
        role: 3
      });
       console.log('update values', JSON.parse(ins));
       return false;
      partnerSubscriptionAfterRazorPayLinks(ins).then((res) => {
        let toastr = '';
        if (res.status === 1) {
          toastr = window.toastr.success;
          toastr('', 'Subscription and Upgradation has been successfully done.', {
            positionClass: "toast-bottom-right",
            containerId: "toast-bottom-right"
          });
          
        } else {
          let er = res.message
          toastr = window.toastr.error; //warning
          toastr(er, toastr, {
            positionClass: "toast-bottom-right",
            containerId: "toast-bottom-right"
          });
        }
      });
    } else {
      let toastr = '';
      toastr = window.toastr.error; //warning
      toastr('', 'Failed to process', {
        positionClass: "toast-bottom-right",
        containerId: "toast-bottom-right"
      });
    }
  }    


    render() {

        const created_date = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(this.state.detail.created_date);
        
         var amount_formatted = (this.state.detail.amount/100);

        const amount = new Intl.NumberFormat('en-IN', {
                style: 'currency',
                currency: 'INR'
              }).format(amount_formatted);

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Payment Detail</h4>
                 
                   <div className="box-shadow-custom">
                                    
                                    <div class="row">
                                        <div class="col-lg-8">

                                    <div class="card mb-4">
                                        <div class="card-header">
                                            <div class="card-title">Payment Info</div>
                                        </div>
                                        <div class="card-body">

                                            <div class="paymentinfo">
                                                
                                                <ul>

                                                    <li>Payment Gateway: <b>RAZORPAY Payment Links</b></li>
                                                    
                                                    <li>Date Paid: <b>{created_date}</b></li>

                                                    <li>Payment Link: <b>{this.state.detail.short_url}</b></li>

                                                    <li>Generated By: <b>{this.state.detail.whogenerated}</b></li>


                                                </ul>

                                            </div>

                                        </div>
                                    </div>

                                         </div>

                                         <div class="col-lg-4">

                                          <div class="card mb-4">
                                                <div class="card-header">
                                                    <div class="card-title">Amount</div>
                                                </div>
                                                <div class="card-body">

                                                    <div class="amountpaid">{amount}</div>
                                                    <div>Discount: <b>&#8377;{Number(180).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</b></div>

                                                </div>
                                            </div>


                                         </div>

                                        </div>

                                        <div class="row">

                                         <div class="col-lg-4 paymentinfo">

                                          <div class="card mb-4">
                                                <div class="card-header">
                                                    <div class="card-title">Partner Info</div>
                                                </div>
                                                <div class="card-body">

                                                    <ul>

                                                    <li><b>{this.state.detail.partner_name}</b></li>
                                                    
                                                    <li>{this.state.detail.partner_first_name} {this.state.detail.partner_last_name}</li>

                                                    <li>Email: {this.state.detail.partner_email}</li>

                                                    <li>Ph: {this.state.detail.partner_phone}</li>

                                                    <li>Address: {this.state.detail.partner_address}</li>

                                                    </ul>

                                                </div>
                                            </div>


                                         </div>

                                         <div class="col-lg-4 paymentinfo">

                                          <div class="card mb-4">
                                                <div class="card-header">
                                                    <div class="card-title">Plan Info</div>
                                                </div>
                                                <div class="card-body">

                                                    <ul>

                                                    <li><b>{this.state.detail.plan_name}</b></li>
                                                    
                                                     

                                                    </ul>

                                                </div>
                                            </div>


                                         </div>



                                    </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <button class="btn btn-primary" onClick={this.handleSubscribe}>Approve and Upgrade</button>
                                            </div>
                                        </div>
                                </div>
  


                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default paymentsLinksDetail;


// WEBPACK FOOTER //
// ./src/components/bewise/paymentsLinksDetail.jsx